import React, { useState } from 'react'
import { FiMapPin, FiMenu, FiPhone, FiX } from 'react-icons/fi'
import { Link, useLocation } from 'react-router-dom'
import { useStudio } from '../context/StudioContext'
import { resolveMediaUrl } from '../services/api'

export default function Header() {
  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()
  const { studio } = useStudio()

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/team', label: 'Studio' },
    { path: '/booking', label: 'Book Now' },
    { path: '/contact', label: 'Contact' },
  ]

  return (
    <header className="sticky top-0 z-50 border-b border-white/40 bg-[rgba(250,245,239,0.85)] backdrop-blur-xl">
      <div className="border-b border-stone-200/70">
        <div className="section-shell flex h-10 items-center justify-between text-xs font-semibold uppercase tracking-[0.2em] text-stone-500">
          <div className="flex items-center gap-2">
            <FiMapPin className="text-[11px] text-rose-700" />
            <span>{studio?.city || 'Tampa, Florida'}</span>
          </div>
          <a href={studio ? `tel:+1${studio.phone}` : 'tel:+18138503700'} className="hidden items-center gap-2 sm:flex">
            <FiPhone className="text-[11px] text-rose-700" />
            <span>{studio?.phoneDisplay || '(813) 850-3700'}</span>
          </a>
        </div>
      </div>

      <div className="section-shell">
        <div className="flex h-20 items-center justify-between">
          <Link to="/" className="flex items-center gap-4">
            <div className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-full border border-stone-200 bg-white shadow-sm">
              {studio?.profileImageUrl ? (
                <img
                  src={resolveMediaUrl(studio.profileImageUrl)}
                  alt={studio.name}
                  className="h-full w-full object-cover"
                />
              ) : (
                <span className="font-heading text-2xl text-rose-700">M</span>
              )}
            </div>
            <div>
              <p className="font-heading text-2xl leading-none text-stone-900">Maya Nails Spa</p>
              <p className="mt-1 text-xs uppercase tracking-[0.22em] text-stone-500">
                Nails / Beauty / Laser
              </p>
            </div>
          </Link>

          <nav className="hidden items-center gap-2 lg:flex">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`rounded-full px-4 py-2 text-sm font-semibold transition-all ${
                  location.pathname === item.path
                    ? 'bg-stone-900 text-white shadow-lg'
                    : 'text-stone-600 hover:bg-white hover:text-stone-900'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <Link to="/booking" className="hidden lg:inline-flex primary-button">
            Book Your Visit
          </Link>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="inline-flex items-center justify-center rounded-full border border-stone-200 bg-white p-3 text-stone-700 shadow-sm lg:hidden"
          >
            {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>

        {isOpen && (
          <div className="space-y-2 border-t border-stone-200/70 pb-5 pt-4 lg:hidden">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`block rounded-2xl px-4 py-3 text-base font-semibold ${
                  location.pathname === item.path
                    ? 'bg-stone-900 text-white'
                    : 'bg-white/80 text-stone-700'
                }`}
                onClick={() => setIsOpen(false)}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/booking"
              className="primary-button mt-2 flex w-full items-center justify-center"
              onClick={() => setIsOpen(false)}
            >
              Book Your Visit
            </Link>
          </div>
        )}
      </div>
    </header>
  )
}
